

export class OptimizeNowJoin {
	
	constructor() {

	}

	submitForm() {
		// validate the form
		let form: any = document.querySelector("#surveyForm");
		if (form.checkValidity()) {
			let piEmail = $('#piEmail').val();
			let piName = $('#piName').val();
			let compName = $('#compName').val();
			let compEmail = $('#compEmail').val();
			let institution = $('#institution').val();
			$.post('/api/optimizenow/joinus', { PIEmail: piEmail, PIName: piName, ContactEmail: compEmail, ContactName: compName, Institution: institution }).done((data) => {
				$('#surveyDialog').modal('hide');
				$('#emailToast').fadeIn();

				$('#piEmail').val('');
				$('#piName').val('');
				$('#compName').val('');
				$('#compEmail').val('');
				$('#institution').val('');

				setTimeout(() => {
					$('#emailToast').fadeOut();
				}, 5000);
			});
		}

		form.classList.add('was-validated');
		// grab form elements
	}
}